import { Button } from '@loomhq/lens';
import React from 'react';

import { DASHBOARDING_ONBOARDING_CARD_CTA_CLICKED } from 'constants/events';
import { MANAGE_WORKSPACE } from 'constants/routes';
import { CUSTOMIZE_BRANDING_CARD_KEY } from 'constants/workspaceOnboarding';
import * as analytics from 'utilities/analytics';

import DashboardOnboardingCard from '../..';

import { CustomBrandingSvg } from 'components/videos-dashboard-ta/empty-library-ta/icons';

const CustomizeBrandingCard = ({ cardConfig }) => {
  const primaryAction = (
    <Button
      onClick={() => {
        analytics.track(DASHBOARDING_ONBOARDING_CARD_CTA_CLICKED, {
          type: 'primary',
          card: CUSTOMIZE_BRANDING_CARD_KEY,
        });
        window.location.href = `${MANAGE_WORKSPACE}#appearance`;
      }}
    >
      Go to settings
    </Button>
  );

  return (
    <DashboardOnboardingCard
      cardKey={CUSTOMIZE_BRANDING_CARD_KEY}
      cardConfig={cardConfig}
      heading="Customize the video share page"
      description="Add a logo and change the color to match your brand."
      centerpiece={<CustomBrandingSvg />}
      primaryAction={primaryAction}
    />
  );
};

export default CustomizeBrandingCard;
